<h4 class="mb-3 mt-4" *ngIf="hasDocs && title">{{ title }}</h4>

<ng-container *ngIf="hasDocs">
  <div class="card flex align-items-center gap-2 flex-wrap">
    <span *ngFor="let item of data">
      <app-document-link [data]="item"></app-document-link>
    </span>
  </div>
</ng-container>
